import IntranetLayout from "@/components/IntranetLayout";
import ModuleHeader from "@/components/voff/ModuleHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

const MATRIX = [
  { role: "Master", required: ["STCW II/2 Master <3000GT","HSC Type Rating","DP Operator (Unlimited)","BOSIET","HUET","SEMS II"], gaps: 0, holders: 4 },
  { role: "Chief Engineer", required: ["STCW III/2 CE","HSC Engineer","BOSIET","Marine Diesel"], gaps: 1, holders: 4 },
  { role: "DP Officer", required: ["STCW II/1 OOW","DP Operator (Limited)","BOSIET","ECDIS"], gaps: 2, holders: 8 },
  { role: "AB / Deck", required: ["STCW II/4","BOSIET","Crane Op (offshore)","Banksman/Slinger"], gaps: 3, holders: 12 },
];
const NEEDS = [
  { course: "DP Operator Refresher", priority: "HIGH", count: 4, vendor: "Kongsberg Academy", cost: "$8,400" },
  { course: "BOSIET Renewal", priority: "HIGH", count: 6, vendor: "Falck Safety", cost: "$5,700" },
  { course: "HUET", priority: "MEDIUM", count: 3, vendor: "Survival Systems", cost: "$2,250" },
  { course: "SEMS II Orientation (ExxonMobil)", priority: "CRITICAL", count: 8, vendor: "ExxonMobil portal", cost: "$0" },
];

const TrainingNeeds = () => (
  <IntranetLayout>
    <ModuleHeader title="Training Needs Analyser" subtitle="Crew Competency Gap Analysis & Training Plan" accent="lime"
      stats={[{ label: "Active gaps", value: 6, tone: "alert" }, { label: "Q2 budget", value: "$16.4k" }]} />
    <div className="grid lg:grid-cols-2 gap-6">
      <Card className="border-[#D0DDE6]"><CardContent className="p-5">
        <h3 className="font-bold text-[#00283C] mb-3">Competency Matrix by Role</h3>
        <table className="w-full text-sm"><thead><tr className="border-b text-xs uppercase text-[#6B8A9A]"><th className="py-2 text-left">Role</th><th>Holders</th><th>Required Certs</th><th>Gaps</th></tr></thead>
          <tbody>{MATRIX.map(m => (<tr key={m.role} className="border-b border-[#D0DDE6]/50"><td className="py-2 font-bold">{m.role}</td><td>{m.holders}</td><td className="text-xs">{m.required.join(", ")}</td><td><Badge className={m.gaps === 0 ? "bg-[#2CA048] text-white" : "bg-[#E8A020] text-white"}>{m.gaps}</Badge></td></tr>))}</tbody></table>
      </CardContent></Card>
      <Card className="border-[#D0DDE6]"><CardContent className="p-5">
        <h3 className="font-bold text-[#00283C] mb-3">Recommended Training Plan</h3>
        {NEEDS.map(n => (
          <div key={n.course} className="border-b border-[#D0DDE6]/50 py-3">
            <div className="flex justify-between items-center"><div className="font-bold text-sm text-[#00283C]">{n.course}</div><Badge className={n.priority === "CRITICAL" ? "bg-[#C83228] text-white" : n.priority === "HIGH" ? "bg-[#E8A020] text-white" : "bg-[#288CC8] text-white"}>{n.priority}</Badge></div>
            <div className="text-xs text-[#6B8A9A] mt-1">{n.count} crew • {n.vendor} • {n.cost}</div>
          </div>
        ))}
        <Button onClick={() => toast.success("Created: Generate Q2 Training Plan", { description: "New entry added." })} className="w-full mt-3 bg-[#288CC8] text-white"><Sparkles className="w-3 h-3 mr-1" />Generate Q2 Training Plan</Button>
      </CardContent></Card>
    </div>
  </IntranetLayout>
);
export default TrainingNeeds;
